import image1 from '@/assets/images/news/detail/20201109/1.jpg';
import image2 from '@/assets/images/news/detail/20201109/2.jpg';
import image3 from '@/assets/images/news/detail/20201109/3.jpg';
import image4 from '@/assets/images/news/detail/20201109/4.jpg';
import image5 from '@/assets/images/news/detail/20201109/5.jpg';
import image6 from '@/assets/images/news/detail/20201109/6.jpg';
import image7 from '@/assets/images/news/detail/20201109/7.png';
import image8 from '@/assets/images/news/detail/20201109/8.jpg';

export default {
  id: '20201109', //  模块 id
  title: '叮咚买菜总部消防演习图记 | “火”速行动 防患于未“燃”', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text:
        '虽然已经过了立冬，暖阳还是分外耀眼。11月9日，伴随着热烈的阳光，叮咚买菜总部2020消防演习正式拉开帷幕......',
      isIndent: false,
    },
    {
      type: 0,
      text: '消防疏散',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '11月9日14时，6号楼茶水间飘出“滚滚浓烟”，消防警铃随即拉响，安保同事到达“案发现场”查看过火情况，并引导小伙伴们疏散撤离。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '浓烟笼罩下的办公楼，不断回响的消防警报声，小伙伴们纷纷丢下手中的工作，从各楼层消防通道，紧张而有序的撤离“火灾现场”。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text: '撤离全程用时5分59秒，各楼层小伙伴陆续到达指定集合地点。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text:
        '叮咚义务消防员统计完人数，副组长随即向组长汇报人员疏散情况：“组长同志，叮咚买菜总部消防演习集合完毕，共计920人成功疏散，无人滞留火场，请指示！”',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: 0,
      text:
        '“每个人只有一条命，如果我们学会了在火灾中怎么逃生，就等于给自己加了一条命。我们聚在一起办公，平时人特别多，所以我们更要注意可能发生的火灾。多留意消防疏散通道，不在办公室使用大功率电器，不在办公楼抽烟......都是我们需要注意的点。”',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '值得点赞的是，本次演习圆满成功，所有小伙伴都成功“逃离火场”，没有一人“伤亡”。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 0,
      text: '灭火实操',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '在消防疏散演习结束后，一些小伙伴还来到了灭火器实操演习区，2名消防员同志为叮咚的小伙伴们讲解了灭火器的正确使用方法：先解开红色保险绳，再拔出银色插销，一手握紧喷头对准火源，一手按压手柄灭火。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image6],
    },
    {
      type: 0,
      text: '小伙伴们跃跃欲试，亲自动手参与“灭火行动”。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image7],
    },
    {
      type: 1,
      title: '',
      src: [image8],
    },
    {
      type: 0,
      text:
        '随着火焰的扑灭，小伙伴们纷纷回到工作岗位。感谢大家的积极参与，相信通过这次实践，大家都能在面对火灾时临危不惧，希望永远遇不到火灾，希望即便遇到火灾我们也能成功逃生。人人都要提高消防安全意识，掌握消防逃生技能，热爱自己的生命！',
      isIndent: false,
    },
  ],
};
